import { render, staticRenderFns } from "./bolseirosListagem.vue?vue&type=template&id=29eed50c&scoped=true&"
import script from "./bolseirosListagem.vue?vue&type=script&lang=js&"
export * from "./bolseirosListagem.vue?vue&type=script&lang=js&"
import style0 from "./bolseirosListagem.vue?vue&type=style&index=0&id=29eed50c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eed50c",
  null
  
)

export default component.exports